export default "__VITE_ASSET__bcWhqSY8O1AaUSfDwsZK4A__"